import type { ErrorComponentProps } from "@tanstack/react-router";
import { Button } from "@wags/ui/button.tsx";
import {
    PageErrorState,
    ReturnToFindAction,
} from "@/components/shared/ErrorState";
import { NotFoundState } from "@/components/shared/NotFound";
import { getRouteErrorPresentation } from "./route-error-presentation";

export function RouteErrorBoundary({ reset, error }: ErrorComponentProps) {
    const presentation = getRouteErrorPresentation(
        error instanceof Error ? error.message : "",
    );

    if (presentation.kind === "not-found") {
        return (
            <NotFoundState
                title={presentation.title}
                description={presentation.description}
                actions={<ReturnToFindAction />}
            />
        );
    }

    return (
        <PageErrorState
            title={presentation.title}
            description={presentation.description}
            scene={presentation.kind === "expired" ? "waiting" : "detour"}
            onRetry={presentation.kind === "generic" ? reset : undefined}
            actions={
                presentation.kind === "expired" ? (
                    <ReturnToFindAction />
                ) : (
                    <Button variant="outline" onClick={() => history.back()}>
                        Go back
                    </Button>
                )
            }
        />
    );
}
